import React from 'react';
import { useIntl } from 'react-intl';
import CustomToolTip from '../../../../ui/CustomToolTip';
import { DocumentErrorExporter } from '../../../../components/DocumentErrorExporter';
import { ReactComponent as ExportIcon } from '../../../../ui/Icons/exportError.svg';
import * as Styled from './styled';

const DocumentStatusTooltip = ({ id, label, jobId, title, delay }) => {
  const intl = useIntl();

  const formattedLabel =
    label && label !== '' && intl.formatMessage({ id: label });

  return (
    <CustomToolTip
      id={'DocumentStatusTooltip-' + id}
      trigger={
        jobId &&
        title && (
          <DocumentErrorExporter label={label} jobId={jobId} title={title}>
            <Styled.ExportIconWrapper>
              <ExportIcon />
            </Styled.ExportIconWrapper>
          </DocumentErrorExporter>
        )
      }
    >
      <Styled.ContentWrapper>{formattedLabel}</Styled.ContentWrapper>
    </CustomToolTip>
  );
};

export default DocumentStatusTooltip;
